<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/investidor/pitch-days/${$route.params.idPitchDay}/startups`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para listagem das
              startups</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-4 order-lg-1">
          <card shadow type="secondary" class="text-center">
            <div class="card-profile-image">
              <img
                v-if="startup.logo"
                :src="startup.logo.url"
                class="card-image my-3"
                alt="..."
              />
            </div>
            <div class="card-body mt-9 py-0">
              <h2 class="card-title text-orange mb-1">
                {{ startup.name }}
              </h2>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i>{{ startup.city || "..." }},
                  {{ startup.state || "..." }}
                </div>
              </div>
              <p class="ml-2 text-sm mt-3">
                <i class="fas fa-quote-left mr-1"></i
                >{{ startup.one_sentence_pitch
                }}<i class="fas fa-quote-right ml-1"></i>
              </p>
              <hr class="my-4" />
              <div v-if="startup.subscription" class="text-left">
                <div>
                  <h6 class="heading-small text-muted mb-4">Sobre a startup</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Pricipal setor de
                    atuação:
                    <span class="text-muted">
                      {{ startup.sector }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Data de fundação:
                    <span class="text-muted">
                      {{ formatDate(startup.foundation) }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Incubada:
                    <span class="text-muted">
                      {{
                        startup.subscription.startup_is_incubated
                          ? "Sim"
                          : "Não"
                      }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Número de sócios:
                    <span class="text-muted">
                      {{ startup.subscription.startup_number_partners }}
                    </span>
                  </p>
                  <div
                    v-if="
                      startup.subscription.startup_equity &&
                      startup.subscription.startup_equity.length
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Estrutura de equity:
                    </p>
                    <ul class="description">
                      <li
                        v-for="(socio, index) in startup.subscription
                          .startup_equity"
                        :key="`socio_${index}`"
                      >
                        {{ socio }}
                      </li>
                    </ul>
                  </div>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Número de colaboradores:
                    <span class="text-muted">
                      {{ startup.subscription.startup_number_employees }}
                    </span>
                  </p>
                </div>
                <hr class="my-4" />
                <div>
                  <h6 class="heading-small text-muted mb-4">Produto/serviço</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Nome:
                    <span class="text-muted">
                      {{ startup.subscription.product_name }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Setor alvo:
                    <span class="text-muted">
                      {{ startup.subscription.product_sector }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Estágio de
                    desenvolvimento:
                    <span class="text-muted">
                      {{ startup.subscription.product_development_stage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Lançamento da solução:
                    <span class="text-muted">
                      {{ formatDate(startup.subscription.product_launch_date) }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Descrição:
                    <span class="text-muted">
                      {{ startup.subscription.product_description }}
                    </span>
                  </p>
                </div>
                <hr class="my-4" />
                <div>
                  <h6 class="heading-small text-muted mb-4">Negócio</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Tecnologia de
                    desenvolvimento próprio:
                    <span class="text-muted">
                      {{
                        startup.subscription.product_own_technology
                          ? "Sim"
                          : "Não"
                      }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Mercardo alvo:
                    <span class="text-muted">
                      {{ startup.subscription.product_target_market }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Vantagem competitiva:
                    <span class="text-muted">
                      {{ startup.subscription.product_competitive_advantage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Estratégia de negócio:
                    <span class="text-muted">
                      {{ startup.subscription.product_bussiness_strategy }}
                    </span>
                  </p>
                  <p class="text-sm mb-1">
                    <i class="fas fa-arrow-right"></i> Mais informações:
                  </p>
                  <ul class="description mb-0">
                    <li
                      v-for="(link, index) in startup.subscription
                        .product_more_information"
                      :key="`link_${index}`"
                    >
                      {{ link }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-8 mt-lg-0 mt-3">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    Avaliação técnica -
                    <span class="text-warning">{{
                      startup.name || "Startup"
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-12">
              <h6 class="heading-small text-muted mb-4">
                <i class="fab fa-youtube mr-1"></i> Pitch vídeo
              </h6>
              <div class="video-wrap">
                <div class="video-container">
                  <iframe
                    v-if="startup.subscription"
                    :src="
                      getUrl(
                        startup.subscription.startup_pitch_video_youtube_id
                      )
                    "
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  >
                  </iframe>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <div class="col">
              <div>
                <h6 class="heading-small text-muted mb-4">
                  <i class="far fa-file-pdf mr-1"></i> Pitch deck
                  <a
                    v-if="startup.subscription && startup.subscription.deck"
                    :href="startup.subscription.deck.url"
                    target="_blank"
                    class="btn btn-sm btn-primary float-right"
                  >
                    <i class="fas fa-file-download"></i> Baixar
                  </a>
                </h6>
                <div class="row mt-3">
                  <div class="col text-center">
                    <div
                      v-if="startup.subscription && startup.subscription.deck"
                    >
                      <pdf
                        style="margin: 0 auto; width: 90%; max-width: 700px"
                        ref="startupDeck"
                        :src="startup.subscription.deck.url"
                        :page="deck.page"
                        @num-pages="deck.pageCount = $event"
                        @page-loaded="deck.currentPage = $event"
                      ></pdf>
                      <div class="text-center mt-2">
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-left"
                          size="sm"
                          class="mr-0"
                          @click="previousPage()"
                          :disabled="this.deck.page <= 1"
                        ></base-button>
                        <span class="mx-3 text-sm"
                          >{{ deck.currentPage }} / {{ deck.pageCount }}</span
                        >
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-right"
                          size="sm"
                          class="mr-0"
                          @click="nextPage()"
                          :disabled="this.deck.page >= this.deck.pageCount"
                        ></base-button>
                      </div>
                    </div>
                    <div v-else>
                      <badge type="info"> Pitch deck não encontrado </badge>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <h6 class="heading-small text-muted mb-4">
                <i class="fas fa-comment-dots mr-1"></i> Breves Considerações
                <span class="text-warning">Stars</span>
              </h6>
              <div class="ml-3 pi-container-read-only">
                <quill-editor
                  v-if="startup.subscription && startup.subscription.note"
                  v-model="startup.subscription.note.considerations_stars"
                  :options="editorReadOnly"
                  disabled="disabled"
                >
                </quill-editor>
                <p v-else>N/A</p>
              </div>
            </div>
          </card>
          <card shadow type="secondary" class="mt-3">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Painel de avaliação</h3>
                </div>
              </div>
            </div>
            <div>
              <div
                class="row"
                v-for="(question, index) in pitchDay.questions"
                :key="index"
              >
                <div class="col-md-8">
                  <h4>{{ index + 1 }}. {{ question.title }}</h4>
                  <p>{{ question.description }}</p>
                </div>
                <div class="col-md-4">
                  <div class="estrelas">
                    <input
                      type="radio"
                      :id="'star_0_question_' + question.id"
                      :name="'response_question_' + question.id"
                      value="0"
                      checked
                    />
                    <label :for="'star_1_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_1_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="1"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_2_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_2_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="2"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_3_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_3_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="3"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_4_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_4_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="4"
                      v-model="model.answers[question.id]"
                    />
                    <label :for="'star_5_question_' + question.id"
                      ><i class="fa"></i
                    ></label>
                    <input
                      type="radio"
                      :id="'star_5_question_' + question.id"
                      :name="'response_question_' + question.id"
                      :value="5"
                      v-model="model.answers[question.id]"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <div class="mb-4">
              <span class="form-control-label mr-3"
                >Você indicaria este investimento?</span
              >
              <div class="form-check form-check-inline mr-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="radioAdviseInvestiment"
                  id="notAdviseInvestimetRadio"
                  :value="false"
                  v-model="model.advise_investiment"
                />
                <label class="form-check-label" for="notAdviseInvestimetRadio"
                  >Não</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="radioAdviseInvestiment"
                  id="adviseInvestimetRadio"
                  :value="true"
                  v-model="model.advise_investiment"
                />
                <label class="form-check-label" for="adviseInvestimetRadio"
                  >Sim</label
                >
              </div>
            </div>
            <hr class="my-4" />
            <div>
              <base-input label="Algum comentário? (opcional)">
                <textarea
                  rows="2"
                  v-model="model.comment"
                  class="form-control"
                  placeholder="Digite aqui..."
                >
                </textarea>
              </base-input>
            </div>
            <div class="text-center">
              <base-alert v-if="error" type="danger" class="text-center">{{
                error
              }}</base-alert>
              <base-button type="warning" :custom="true" @click="handleSubmit">
                <span v-if="!isUpdate">Avaliar startup</span>
                <span v-else>Atualizar avaliação</span>
              </base-button>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import api from "@/services/api.js";
import pdf from "vue-pdf";

export default {
  name: "avaliacao",
  components: {
    pdf,
    quillEditor,
  },
  data() {
    return {
      model: {
        answers: {},
        advise_investiment: null,
        comment: "",
      },
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble",
      },
      isUpdate: false,
      startup: "",
      pitchDay: "",
      error: "",
      deck: {
        page: 1,
        currentPage: 0,
        pageCount: 0,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
    });
    await this.loadSubscription();
    await this.loadEvaluation();
    loader.hide();
  },
  methods: {
    async loadSubscription() {
      try {
        const {
          data: { pitchDay, startup },
        } = await api.get(
          `/investor-pitch-days/${this.$route.params.idPitchDay}/subscriptions/${this.$route.params.idSubscription}`
        );
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (!pitchDay || !startup) {
          this.$toasted.error(
            "Ocorreu um erro ao recuperar a startup para a avaliação"
          );
          this.$router.push("/investidor/avaliacoes");
        }
        if (!startup.logo) startup.logo = { url: defaultLogoPath };
        this.pitchDay = pitchDay;
        try {
          const links = JSON.parse(
            startup.subscription.product_more_information
          );
          startup.subscription.product_more_information = links.map(
            (link) => `${link.title || "Link"}: ${link.link}`
          );
        } catch (e) {
          startup.subscription.product_more_information = [
            startup.subscription.product_more_information,
          ];
        }
        try {
          const socios = JSON.parse(startup.subscription.startup_equity);
          startup.subscription.startup_equity = socios.map(
            (socio) => `${socio.title}: ${socio.percentage}%`
          );
        } catch (e) {
          startup.subscription.startup_equity = [
            startup.subscription.startup_equity,
          ];
        }
        this.startup = startup;

        pitchDay.questions.forEach((question) => {
          this.model.answers[question.id] = 0;
        });
        this.model.subscription_id = this.$route.params.idSubscription;
        return;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
        this.$router.push(
          `/investidor/pitch-days/${this.$route.params.idPitchDay}/startups`
        );
      }
    },
    async loadEvaluation() {
      try {
        const { data } = await api.get(
          `/investor-pitch-days/${this.$route.params.idPitchDay}/responses/${this.$route.params.idSubscription}`
        );
        if (data) {
          this.isUpdate = true;
          this.pitchDayEvaluationId = data.id;
          this.model.advise_investiment =
            data.advise_investiment === 1 ? true : false;
          this.model.comment = data.comment;
          data.answers.forEach((answer) => {
            if (this.model.answers[answer.question_id] === 0)
              this.model.answers[answer.question_id] = answer.stars;
          });
        }
      } catch (e) {
        this.error = "Ocorreu um erro ao recuperar as informações";
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
        this.$router.push(
          `/investidor/pitch-days/${this.$route.params.idPitchDay}/startups`
        );
      }
    },
    async handleSubmit() {
      this.error = "";
      if (!this.isValidModel()) {
        this.error =
          "Por favor, complete a ficha avaliação antes de continuar.";
        return;
      }
      try {
        const url = `/investor-pitch-days/${this.$route.params.idPitchDay}/responses`;
        if (!this.isUpdate) {
          await api.post(url, this.model);
        } else {
          await api.put(`${url}/${this.pitchDayEvaluationId}`, this.model);
        }
        this.$toasted.show(
          `Avaliação ${this.isUpdate ? "salva" : "atualizada"} com sucesso`
        );
        this.$router.push(
          `/investidor/pitch-days/${this.$route.params.idPitchDay}/startups`
        );
      } catch (e) {
        this.error = `Ocorreu um erro ao ${
          this.isUpdate ? "salvar" : "atualizar"
        } a avaliação. Tente novamente.`;
        this.$toasted.error(
          `Ocorreu um erro ao ${
            this.isUpdate ? "salvar" : "atualizar"
          } a avaliação`
        );
      }
    },
    adviseInvestimentChangedHandler() {
      if (typeof event === "boolean") this.model.advise_investment = event;
    },
    isValidModel() {
      if (this.model.advise_investiment === null) return false;
      const answers = this.model.answers;
      for (let answer in answers) {
        if (answers[answer] === 0) return false;
      }
      return true;
    },
    getUrl(youtubeVideoId) {
      return `https://www.youtube.com/embed/${youtubeVideoId}`;
    },
    nextPage() {
      if (this.deck.pageCount > this.deck.page) this.deck.page++;
    },
    previousPage() {
      if (this.deck.page > 1) this.deck.page--;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}

.estrelas {
  text-align: right;
  margin-top: 2px;
  margin-right: 3%;
}

.estrelas input[type="radio"] {
  display: none;
}

.estrelas label i.fa:before {
  content: "\f005";
  color: #ff4200;
  font-size: 1.8em;
}

.estrelas input[type="radio"]:checked ~ label i.fa:before {
  color: #ccc;
}

.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 50%;
}

.video-container iframe,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.video-wrap {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
</style>
<style>
.pi-container-read-only .quill-editor .ql-container,
.pi-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 13rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
